// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"791d5967","196":"3a370cf4","223":"fd4d657f","447":"96bdb937","646":"3c2bf7dd"}[chunkId] + ".css";
};